function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117 60C117 91.4802 91.4802 117 60 117C28.5198 117 3 91.4802 3 60C3 28.5198 28.5198 3 60 3C91.4802 3 117 28.5198 117 60Z",
  stroke: "white",
  strokeWidth: 6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87 59.5C87 74.6878 74.6878 87 59.5 87C44.3122 87 32 74.6878 32 59.5C32 44.3122 44.3122 32 59.5 32C74.6878 32 87 44.3122 87 59.5ZM92 59.5C92 77.4493 77.4493 92 59.5 92C41.5507 92 27 77.4493 27 59.5C27 41.5507 41.5507 27 59.5 27C77.4493 27 92 41.5507 92 59.5ZM59.5 76.5C50.0495 76.5 42.5 69.0519 42.5 60H37.5C37.5 71.9349 47.4114 81.5 59.5 81.5C71.5887 81.5 81.5 71.9349 81.5 60H76.5C76.5 69.0519 68.9505 76.5 59.5 76.5ZM54 52.5C54 54.433 52.433 56 50.5 56C48.567 56 47 54.433 47 52.5C47 50.567 48.567 49 50.5 49C52.433 49 54 50.567 54 52.5ZM68.5 56C70.433 56 72 54.433 72 52.5C72 50.567 70.433 49 68.5 49C66.567 49 65 50.567 65 52.5C65 54.433 66.567 56 68.5 56Z",
  fill: "white"
});

function SvgMainSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSmile);
export default __webpack_public_path__ + "static/media/mainSmile.ee803853.svg";
export { ForwardRef as ReactComponent };